import * as React from "react";
import { createPortal } from "react-dom";
import { connect, type ConnectedProps } from "react-redux";
import { type RootState } from "../../Reducers/ShopfrontReducers";

const connector = connect((state: RootState) => ({
    overlayShown: (
        state.layout.body.overlay ||
        state.layout.notifications.open ||
        state.layout.menu.open ||
        state.layout.userMenu.open
    ),
}));

type PropsFromRedux = ConnectedProps<typeof connector>;

interface Props extends PropsFromRedux {
    children: React.ReactNode;
}

export class FixedPosition extends React.Component<Props> {
    public element = document.getElementById("fixed-position-wrapper");

    public componentDidMount(): void {
        if(!this.element) {
            console.error("FixedPosition component cannot find the #fixed-position-wrapper Element");
        }

        this.updateElementClass(this.props.overlayShown);
    }

    public componentDidUpdate(prevProps: Readonly<Props>): void {
        if(prevProps.overlayShown !== this.props.overlayShown) {
            this.updateElementClass(this.props.overlayShown);
        }
    }

    public updateElementClass = (overlay: boolean): void => {
        if(!this.element) {
            return;
        }

        if(overlay) {
            this.element.classList.add("menu-open");
        } else {
            this.element.classList.remove("menu-open");
        }
    };

    public render(): React.ReactNode {
        if(process.env.NODE_ENV === "test") {
            return this.props.children;
        }

        if(!this.element) {
            return null;
        }

        return createPortal(this.props.children, this.element);
    }
}

export default connector(FixedPosition);
